import { Phone, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {

  return (
    <footer className="bg-background relative overflow-hidden border-t border-border pt-32 pb-12 transition-colors duration-500">
      {/* Background patterns */}
      <div className="absolute inset-0 bg-dot-grid opacity-20"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-24 reveal-up">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="text-3xl font-extrabold tracking-tight">
              <img src='logo-no-bg.png' alt="Logo" className="h-12 w-auto" />

            </div>
            <p className="text-foreground/50 font-medium leading-relaxed">
              Ihr zuverlässiger Partner für Sicherheitstechnik und Schlosserei in Wien – seit über zwei Jahrzehnten.
            </p>
            <div className="flex space-x-4">
              {/* Add social icons or trust badges here if needed */}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-bold text-foreground/40 uppercase tracking-widest mb-8">Navigation</h3>
            <ul className="space-y-4">
              {[
                { label: 'Startseite', path: '/' },
                { label: 'Leistungen', path: '/services' },
                { label: 'Über Uns', path: '/about' },
                { label: 'Unser Team', path: '/team' },
                { label: 'Karriere', path: '/karriere' }
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-foreground/70 font-bold hover:text-primary transition-colors text-lg"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h3 className="text-sm font-bold text-foreground/40 uppercase tracking-widest mb-8">Kontakt</h3>
            <div className="space-y-6">
              <div className="flex items-center space-x-3 text-foreground/70 font-bold">
                <Phone size={20} className="text-primary" />
                <a href="tel:+436603022555" className="hover:text-primary transition-colors">+43 660 3022555</a>
              </div>
              <div className="flex items-center space-x-3 text-foreground/70 font-bold">
                <Mail size={20} className="text-primary" />
                <a href="mailto:schlosserei@celic.at" className="hover:text-primary transition-colors">schlosserei@celic.at</a>
              </div>
              <div className="flex items-start space-x-3 text-foreground/70 font-bold leading-tight">
                <MapPin size={20} className="text-primary mt-1 flex-shrink-0" />
                <span>Adelheid-Popp-Gasse 16/1c<br />1220 Wien</span>
              </div>
            </div>
          </div>

          {/* Trust Badge / CTA */}
          <div className="bg-primary/5 p-8 rounded-3xl space-y-4 border border-primary/10">
            <h4 className="text-primary font-extrabold text-xl">Ihr Sicherheits-Partner</h4>
            <p className="text-foreground/70 font-bold text-sm leading-relaxed">
              Wir beraten Sie gerne ausführlich. Rufen Sie uns für eine Terminvereinbarung an.
            </p>
            <a href="tel:+436603022555" className="inline-block bg-primary text-white premium-button text-sm w-full text-center py-3">
              Beratung
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border pt-10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <p className="text-foreground/30 font-bold text-sm">© 2026 Celic GmbH. Alle Rechte vorbehalten.</p>
            <div className="flex space-x-8">
              {['Datenschutz', 'Impressum', 'AGB'].map((label) => (
                <a key={label} href="#" className="text-foreground/30 font-bold text-sm hover:text-primary transition-colors underline decoration-foreground/10 underline-offset-4">
                  {label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;